export class Pagination {
  constructor(pagination = {}) {
    this.perPage = pagination.per_page;
    this.page = pagination.page;
    this.totalRecords = pagination.total_records;
    this.totalPages = pagination.total_pages;
    this.hasMore = pagination.has_more || false;
    this.counts = pagination.counts || {};
  }
}
